import { takeLatest } from "redux-saga/effects";

import { defaultReturn, generateDefaultActions, makePayload, requestSaga } from "../utils/helpers";

const initialState = {};

export const UPDATE_FILE = generateDefaultActions("UPDATE_FILE");
export const updateFile = payload => makePayload(UPDATE_FILE.value, payload);
function* getUpdateFileSaga(payload) {
  yield requestSaga(UPDATE_FILE, "/files", "PUT", payload);
}

export default function fileReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_FILE.success:
      return defaultReturn(state, payload.result, "lastUpdatedFile");
    default:
      return state;
  }
}

export function* fileSaga() {
  yield takeLatest(UPDATE_FILE.value, getUpdateFileSaga);
}
